import { Pipe, PipeTransform } from "@angular/core";
import { Session } from "@models/Session";

@Pipe({name: 'sessionDuration'})
export class SessionDurationPipe implements PipeTransform {

    transform(value: Session, args?: any): string {
        return value.start_time && value.end_time ? Math.ceil((value.end_time - value.start_time) / 60000) + ' min' : '-';
    }
}